import CryptoJS from 'crypto-js';
import api from './axiosInstance';
import { storeEmail, storeName, storeToken } from '../storage';

const Endpoints = {
    authSignUp: 'auth/sign-up/',
    authSignIn: 'auth/sign-in/',
    authSignInByLink: 'auth/sign-in/by-link/',
    authPasswordRecoveryRequest: 'auth/password/recovery-request/',
    authPasswordSetByLink: 'auth/password/set-by-link/',
    validatePromocode: 'pub/promocode/validate/',
};

function hashPassword(rawPassword, email) {
    if (!rawPassword || !email) {
        throw new Error('Пароль и email обязательны');
    }

    const saltedPassword = process.env.REACT_APP_PASSWORD_HASHER + rawPassword + email;
    return CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(saltedPassword)).toString();
}

function toMultipartFormData(payload) {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            formData.append(key, value);
        }
    });

    return formData;
}

function rememberAuthenticatedUser(responseData) {
    if (responseData?.token) {
        storeToken(responseData.token);
    }

    const userData = responseData?.userData;
    if (userData?.email) {
        storeEmail(userData.email);
    }

    if (userData?.name || userData?.email) {
        storeName(userData.name || userData.email);
    }
}

async function postForm(endpoint, payload) {
    const response = await api.post(`/${endpoint}`, toMultipartFormData(payload), {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const responseData = response.data?.data ?? response.data;
    rememberAuthenticatedUser(responseData);

    return responseData;
}

const AuthApi = {
    async validatePromocode(promocode) {
        const response = await api.post(`/${Endpoints.validatePromocode}`, toMultipartFormData({ promocode }), {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 30 * 1000,
            validateStatus: (status) => status === 200 || status === 204,
        });

        if (response.status === 204) {
            return null;
        }

        return response.data;
    },

    authSignUp({
        email,
        name,
        phone,
        promocode = null,
        useProjectScopedLimits = false,
        ...attribution
    }) {
        return postForm(Endpoints.authSignUp, {
            email,
            name,
            phone,
            promocode,
            useProjectScopedLimits,
            ...attribution,
        });
    },

    authSignIn({ email, password }) {
        return postForm(Endpoints.authSignIn, {
            email,
            password: hashPassword(password, email),
        });
    },

    authSignInByLink({ action, ui, key, s }) {
        return postForm(Endpoints.authSignInByLink, {
            action,
            ui,
            key,
            s,
        });
    },

    authPasswordRecoveryRequest({ email }) {
        return postForm(Endpoints.authPasswordRecoveryRequest, { email });
    },

    authPasswordSetByLink({ email, password, k }) {
        return postForm(Endpoints.authPasswordSetByLink, {
            email,
            password: hashPassword(password, email),
            k,
        });
    },
};

export default AuthApi;
